/*
 * @Author: luohongbiao
 * @Date: 2022-01-05 10:01:53
 * @LastEditTime: 2022-06-27 23:37:01
 * @LastEditors: LHB
 * @Description:
 * @FilePath: \shirleyClass\src\router.js
 */
import Vue from 'vue'
import Router from 'vue-router'
const Home = () => import('@/modules/Home/index')
const Login = () => import('@/modules/Login/index')
const Empty = () => import('@/modules/EmptyClass/index')
const Bindwxerror = () => import('@/modules/Bindwxerror/index')
const Openclass = () => import('@/modules/Openclass/index')
const OrderList = () => import('@/modules/OrderList/index')
const Redeem = () => import('@/modules/Redeem/index')
const Express = () => import('@/modules/Express/index')
const Changemobile = () => import('@/modules/Changemobile/index')
const Email = () => import('@/modules/Email/index')
const Edit = () => import('@/modules/Edit/index')
const Reset = () => import('@/modules/Reset/index')
const ChangeWx = () => import('@/modules/ChangeWx/index')
const BindWx = () => import('@/modules/BindWx/index')
const BindLinkerror = () => import('@/modules/BindLinkerror/index')
const SelectWx = () => import('@/modules/SelectWx/index')

Vue.use(Router)

export default new Router({
  // mode: "history",
  routes: [
    {
      path: '/',
      redirect: { name: 'login' }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/empty',
      name: 'empty',
      component: Empty
    },
    {
      path: '/bindwxerror',
      name: 'bindwxerror',
      component: Bindwxerror
    },
    {
      path: '/openclass',
      name: 'openclass',
      component: Openclass
    },
    {
      path: '/orderList',
      name: 'orderList',
      component: OrderList
    },
    {
      path: '/redeem',
      name: 'redeem',
      component: Redeem
    },
    {
      path: '/express',
      name: 'express',
      component: Express
    },
    {
      path: '/changemobile',
      name: 'changemobile',
      component: Changemobile
    },
    {
      path: '/email',
      name: 'email',
      component: Email
    },
    {
      path: '/edit',
      name: 'edit',
      component: Edit
    },
    {
      path: '/reset',
      name: 'reset',
      component: Reset
    },
    {
      path: '/changeWx',
      name: 'changeWx',
      component: ChangeWx
    },
    {
      path: '/bindwx',
      name: 'bindwx',
      component: BindWx
    },
    {
      path: '/bindLinkerror',
      name: 'bindLinkerror',
      component: BindLinkerror
    },
    {
      path: '/selectWx',
      name: 'selectWx',
      component: SelectWx
    }
  ]
})
